enum Country {
    US = 'US',
    CA = 'CA',
}

export { Country };
